import { setupExternalModal } from "./external_modal.js"

const FLOW_NAME = "Always Accept Feature"
const FLOW_END_EVENTS = ["flow_completed", "flow_skipped", "flow_aborted"]

const NotificationPanelHook = {
  mounted() {
    this.retiringDialogs = new WeakSet()
    this.onModalRemoving = ({ target }) => {
      this.retiringDialogs.add(target)
      if (target === this.dialog) this.releaseGuide(false)
    }
    this.onFlowRequest = ({ detail: flow }) => {
      if (
        flow.name !== FLOW_NAME ||
        !this.notificationsDialog() ||
        !this.hasInvite()
      )
        return
      if (
        !window.Appcues ||
        (this.sdk === window.Appcues && this.flowId === flow.id)
      )
        return

      this.unbindFlow()
      this.sdk = window.Appcues
      this.flowId = flow.id
      this.onFlowStarted = (event) => {
        if (event.flowId !== this.flowId) {
          this.flowActive = false
          this.releaseGuide()
          return
        }
        this.flowActive = true
        this.syncGuide()
      }
      this.onFlowEnded = (event) => {
        if (event.flowId !== this.flowId) return
        this.flowActive = false
        this.releaseGuide()
      }
      this.sdk.on("flow_started", this.onFlowStarted)
      for (const name of FLOW_END_EVENTS) this.sdk.on(name, this.onFlowEnded)
    }
    document.addEventListener("enaia:modal-removing", this.onModalRemoving)
    window.addEventListener("enaia:appcues-flow-requested", this.onFlowRequest)

    this.dialogObserver = new MutationObserver(() => this.syncGuide())
    this.dialogObserver.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ["inert", "aria-modal", "aria-owns", "open"],
    })

    this.handleEvent("notification_panel_opened", () => {
      this.syncGuide()
      if (this.hasInvite()) {
        this.pushEventTo(this.el, "trigger-appcues-flow", {
          flowName: FLOW_NAME,
        })
      }
    })

    this.handleEvent("notification_panel_closed", () => {
      this.releaseGuide(false)
      for (const block of document.querySelectorAll(
        ".notification-block.border",
      )) {
        block.classList.remove("border")
      }
    })
  },

  hasInvite() {
    return !!this.el.querySelector(
      "button[data-label='always_accept_partnership_invite']",
    )
  },

  notificationsDialog() {
    return [...this.el.querySelectorAll("dialog[open]")].find(
      (dialog) => !this.retiringDialogs.has(dialog),
    )
  },

  syncGuide() {
    const dialog = this.notificationsDialog()
    const guide = this.flowActive
      ? document
          .querySelector(".appcues appcues-container, .appcues appcues-layer")
          ?.closest(".appcues")
      : null
    if (!dialog || !guide) {
      this.releaseGuide(!!dialog)
      return
    }
    if (this.dialog !== dialog || this.guide !== guide) {
      this.releaseGuide(false)
      this.dialog = dialog
      this.guide = guide
      this.modality = setupExternalModal(dialog, guide)
    }
    this.modality.sync()
  },

  releaseGuide(restoreNative = true) {
    this.modality?.destroy({ restoreNative })
    this.modality = null
    this.dialog = null
    this.guide = null
  },

  unbindFlow() {
    if (this.sdk) {
      this.sdk.off("flow_started", this.onFlowStarted)
      for (const name of FLOW_END_EVENTS) this.sdk.off(name, this.onFlowEnded)
    }
    this.sdk = null
    this.flowActive = false
    this.releaseGuide()
  },

  destroyed() {
    this.dialogObserver.disconnect()
    document.removeEventListener("enaia:modal-removing", this.onModalRemoving)
    window.removeEventListener(
      "enaia:appcues-flow-requested",
      this.onFlowRequest,
    )
    this.releaseGuide(false)
    this.unbindFlow()
  },
}

export { NotificationPanelHook }
